// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle." + {"923":"0e59acce7b6f41f4cc50","944":"de38325fad965326c5c9"}[chunkId] + ".js";
};